/* eslint-disable react/display-name */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { ComponentProps, ComponentType, ReactNode } from 'react';
import { RowColumn } from '../../Containers';
import { Skeleton } from '../../UI';

import { Label } from '../Label';
import { WithLabelCommonProps } from './types';

export type LabelWrapperProps = Omit<WithLabelCommonProps, 'children'> & {
  children: ReactNode;

  id?: string;
};

export function LabelWrapper({
  containerClassName,
  fullWidth,
  gap = '2',
  orientation = 'vertical',

  label,
  labelClassName,
  labelIcon,

  id,

  loading,
  error,

  children,
}: LabelWrapperProps) {
  const hasError = !!error;

  return (
    <RowColumn
      orientation={orientation}
      fullWidth={fullWidth}
      className={containerClassName}
      gap={gap}
    >
      {label && (
        <Label className={labelClassName} htmlFor={id} icon={labelIcon}>
          {label}
        </Label>
      )}

      {loading ? <Skeleton height={36} /> : <>{children}</>}

      {hasError && typeof error == 'string' && (
        <span className="-mt-1 pl-0.5 text-sm text-destructive">{error}</span>
      )}
    </RowColumn>
  );
}

type AddedLabelProps = Omit<LabelWrapperProps, 'children'>;

export function WithLabelWrapper<AnyComponent extends ComponentType<any>>(
  Comp: AnyComponent,
): (props: ComponentProps<AnyComponent> & AddedLabelProps) => JSX.Element {
  const Wrapper = ({
    containerClassName,
    fullWidth,
    gap = '2',
    orientation = 'vertical',

    label,
    labelClassName,
    id,

    loading,
    error,

    ...props
  }: ComponentProps<AnyComponent> & AddedLabelProps) => (
    <LabelWrapper
      containerClassName={containerClassName}
      fullWidth={fullWidth}
      gap={gap}
      orientation={orientation}
      label={label}
      labelClassName={labelClassName}
      id={id}
      loading={loading}
      error={error}
    >
      <Comp {...(props as any)} />
    </LabelWrapper>
  );

  Wrapper.displayName = Comp.displayName;

  return Wrapper;
}
